// Material Kit 2 React pages
import WorkUs from "pages/LandingPages/Work";

export default function ContactUsPage() {
  return <WorkUs />;
}
